import {useCallback} from 'react';
import {EventAction, EventCategory, EventLabel, EventNames} from 'modules/google-analytics/constants';
import {useGtagEventLocation} from 'hooks/analytics/gtag/helpers/useGtagEventLocation';

import {sendGtagEvent} from 'hooks/analytics/gtag/helpers';

export const useCatalogSortGtag = () => {
    const {eventLocation} = useGtagEventLocation();

    return useCallback(
        (eventContent: string) => {
            const dataLayerList = {
                event: EventNames.OWOX,
                eventCategory: EventCategory.Interactions,
                eventAction: EventAction.Switch,
                eventContent,
                eventLocation,
                eventLabel: EventLabel.Sort,
            };
            sendGtagEvent(dataLayerList);
        },
        [eventLocation],
    );
};
